import {PAYMENT_DIRECTORY_PAGES,PAYMENT_METHODS,PAYMENT_METHODS_PATH,paymentMethodPath} from '../src/payment-method-catalog';
import {PaymentDirectoryContent,PaymentGuideContent} from './payment-method-content';
import './payment-methods.css';

function PaymentPage({path}:{path:string}){
  const method=PAYMENT_METHODS.find(item=>paymentMethodPath(item)===path);
  return method?<PaymentGuideContent method={method}/>
    :<PaymentDirectoryContent cryptoOnly={path===`${PAYMENT_METHODS_PATH}/crypto`}/>;
}
export const PAYMENT_PAGES=PAYMENT_DIRECTORY_PAGES.map(page=>({path:page.path,label:page.title,component:()=> <PaymentPage path={page.path}/>}));
